import { Box, FormControl, MenuItem, Select } from '@mui/material';

export default function LocalitySelect({
    locality,
    setLocality,
    options = [],
    marginBottom,
    disabled = false,
}) {
    return (
        <Box sx={{ width: '100%', mb: marginBottom || 0 }}>
            <FormControl fullWidth>
                <Select
                    value={locality}
                    onChange={(e) => setLocality(e.target.value)}
                    displayEmpty
                    disabled={disabled}
                    sx={{
                        borderRadius: '40px',
                        height: '48px',
                        color: 'rgb(39,90,71)',
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgb(39,90,71)',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgb(39,90,71)',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgb(39,90,71)',
                            borderWidth: '2px',
                        },
                        '& .MuiSvgIcon-root': {
                            color: 'rgb(39,90,71)',
                        },
                    }}
                    renderValue={(selected) => {
                        if (!selected) {
                            return (
                                <span style={{ color: 'rgba(39,90,71,0.6)' }}>Select locality</span>
                            );
                        }
                        return selected;
                    }}
                >
                    <MenuItem disabled value="">
                        Select locality
                    </MenuItem>

                    {options.map((option) => (
                        <MenuItem
                            key={option}
                            value={option}
                            sx={{
                                color: 'rgb(39,90,71)',
                            }}
                        >
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
